import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Header } from "src/app/util/headerTwo";
import { LoginResponse } from "src/app/model-response/login-response";
import { ContUsuarios } from "src/app/model/cont_usuarios";
import { BehaviorSubject, Observable, map, of } from "rxjs";
import { forgotPassRequest } from "src/app/model-response/forgotPassRequest";
import { ValideCodigoRequest } from "src/app/model-response/valideCodigoRequest";
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class SigninService {
  private currentUserSubject: BehaviorSubject<ContUsuarios>;
  public currentUser: Observable<ContUsuarios>;
  header: Header = new Header();

  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.currentUserSubject = new BehaviorSubject<ContUsuarios>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  init() {
    this.currentUserSubject = new BehaviorSubject<ContUsuarios>(
      JSON.parse(localStorage.getItem('currentUser') || '{}')
    );
    this.currentUser = this.currentUserSubject.asObservable();
  }

  login(body: LoginResponse): Observable<any> {
    return this.http.post<any>(this.header.url.concat(`login/in`), body).pipe(
      map(user => {
        if (user && user.token) {
          // Guardar usuario y permisos en localStorage
          localStorage.setItem('currentUser', JSON.stringify(user));
          localStorage.setItem('permisos', JSON.stringify(user.permisos));

          // Almacenar token JWT en la cookie
          this.cookieService.set('auth', user.token, {
            secure: false, // Establecer en true si usas HTTPS
            sameSite: 'Lax',
            expires: 1 // Duración de la cookie en días
          });

          this.currentUserSubject.next(user);
        }
        return user;
      })
    );
  }

  logout() {
    // Eliminar el usuario de localStorage y las cookies
    localStorage.removeItem('currentUser');
    localStorage.removeItem('permisos');
    this.cookieService.delete('auth'); // Eliminar la cookie
    this.currentUserSubject.next(this.currentUserValue);
    window.location.reload();
    return of({ success: false });
  }

  ingresar(user: any) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    this.currentUserSubject.next(user);
    return user;
  }

  forgotPassword(correo: forgotPassRequest) {
    return this.http.post<any>(this.header.url.concat(`login/forgotpass`), correo, {
      headers: this.header.parametro
    });
  }

  valideCodigo(body: ValideCodigoRequest) {
    return this.http.post<any>(this.header.url.concat(`login/validecodigo`), body, {
      headers: this.header.parametro
    });
  }

  cambiarEstado(body: any, estado: number) {
    return this.http.post<any>(this.header.url.concat(`login/cambiarestado/${estado}`), body, {
      headers: this.header.parametro
    });
  }

  hasPermission(route: string, permisos: any[]): boolean {
    return permisos.some(permission =>
      permission.submenu.some((p: any) => p.path === route)
    );
  }
}
